<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-icon
            class="mr-2"
            color="grey"
            v-on="on"
          >
            mdi-file-document-plus
        </v-icon>

      </template>
      <v-card>
        <v-toolbar  dark color="blue darken-1">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Registrar Amparo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="resetValidation()">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>


          <v-row >
            <v-col cols="12" class="py-2 pt-6">
                <v-form ref="form" v-model="valid" lazy-validation>

                    <v-container class="mt-3">
                      <v-row>
                        <v-col
                          cols="6"
                          md="3"
                          class="py-0 mb-0 pt-0"
                        >
                          <v-text-field
                            v-on:blur="searchToca()"
                            outlined
                            v-model="amparo"
                            label="Número Amparo"
                            required
                            hint="Solo números"
                            :rules="[rules.required]"
                          >
                            <v-icon slot="append" color="green" v-if="checkedToca">mdi-check</v-icon>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="9"
                          class="py-0 mb-0 pt-0"
                        >
                          <v-autocomplete
                            outlined
                            label="Tribunales"
                            item-text="nombre"
                            item-value="id"
                            persistent-hint
                            :items = "getAllTribunales"
                            v-model="tribunal_id"
                            required
                            :rules="[rules.requiredSelect]"
                            key="tribunal_id"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0 mb-0 pt-0"
                        >
                        <v-menu
                          v-model="menu_fecha_recepcion"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              outlined
                              v-model="fecha_recepcion"
                              label="Recepción"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fecha_recepcion" @input="menu_fecha_recepcion = false">
                          </v-date-picker>
                        </v-menu>

                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="py-0 mb-0 pt-0"

                        >
                          <v-text-field
                            outlined
                            v-model="dias_termino"
                            :counter="10"
                            label="Días de termino"
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="10"
                               class="py-0 mb-0 pt-0"
                        >
                          <div style="background-color:white">
                            <v-text-field
                              outlined
                              name="quejoso"
                              label="Quejoso"
                              v-model="quejoso"
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </div>

                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="12"
                               class="py-0 mb-0 pt-0"
                        >
                          <v-textarea
                            outlined
                            name="efectos"
                            label="Efectos"
                            v-model="efectos"
                            required
                            :rules="[rules.required]"
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="12"
                               class="py-0 mb-0 pt-0"
                        >
                          <v-textarea
                            outlined
                            name="observaciones"
                            label="Observaciones"
                            v-model="observaciones"
                            required
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="12"
                               class="py-0 mb-0 pt-0"
                        >
                        <v-select
                          v-model="tipo_registro"
                          :items="listTipoRegistros"
                          label="Tipo de Registro"
                          item-text="nombre"
                          item-value="val"
                          outlined
                        ></v-select>
                        </v-col>
                      </v-row>

                      <v-btn
                        block
                        dark
                        color="teal"
                        :loading="loading"
                        :disabled="!valid"
                        @click="validate"
                        class="mb-6"
                      >
                        GUARDAR
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>
                      <v-divider></v-divider>

                    </v-container>
                  </v-form>


            </v-col>
          </v-row>

      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import {mapGetters, mapMutations} from "vuex";
  import BaseSelect from "@/components/BaseSelect.vue";
  import Autocomplete from "@/components/Autocomplete";

  export default {
    props: {
      sala_id: {
        type: Number,
        required: true
      },
      apelacion_data: {
        type: Object,
        required: true
      },
    },
    components: { BaseSelect, Autocomplete },
    data: () => ({
      checkedToca: false,
      disabled: true,
      dialog:false,
      menu_fecha_recepcion: false,

      tribunal_id:'', //municipio_id =>para filtrar los juzgados por municipio_id
      materia_id:'', //Civil o Mercantil este es para filtrar el tipo de juciio y traernos as las vias y demas
      reconvencion:null,  //el objeto seleccionado de la reconvencion
      has_reconvencion:false,   //para comportamiento de mostrar o deshabilitar el campo reconvencion
      tipo_registro:'',  //para comportamiento de mostrar ponencias y sirve para registrar un amparo
      listTipoRegistros: [{val:'A',nombre:'Amparo'},{val:'D',nombre:'Defecto'}],

      ponencia_selected:'',
      valid: false,
      loading: false,

      amparo: "",
      numero_oficio: "",
      dias_termino: "",
      quejoso: "",
      efectos: "",
      fecha_recepcion: "",
      observaciones: "",

      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
      this.$store.dispatch("GET_ALL_TRIBUNALES", { url: "/listTribunales" });
    },
    watch: {
      has_reconvencion(){
        if (!this.has_reconvencion) {
          this.reconvencion=null
        }
      }
      },
      toca() {
        this.checkedToca = false;
        if (this.toca.length >= 5) {
          if ( this.toca.includes("/") ) var tocacompleto = this.toca.replace('/','');
          else var tocacompleto = this.toca;
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          if (this.numero) {
            this.toca = this.numero + "/" + this.anio;
          }
        }
    },
    computed: {
      ...mapGetters([
          "currentUser",
          "roleUser",
          "getAllTribunales",
        ]),
    },
    methods:{
      searchToca(){
        var tocacompleto = this.toca.replace('/','');
        this.$store.dispatch("GET_ALL_TOCAS", { url: "apelaciones/existeToca/" + tocacompleto + "/" + this.sala_id  }).then(res=>{
          if ( res.data.message == "existe" ) {
            self = this;
            this.$swal({
              title: "Error",
              text: "El toca ya existe... Favor de returnar",
              icon: "error",
              confirmButtonText: "Aceptar"
            }).then(function() {
              self.$router.push({ path: '/returno' })
              self.dialog = false;
            });
          }else {
            this.checkedToca = true
          }
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
            this.loading = true;
            this.save();
        }
      },
      save() {
        var amparo = {
          // tocacompleto: this.numero + this.anio,
          apelacion_id: this.apelacion_data.id,
          numero_oficio:this.numero_oficio,
          fecha_recepcion: this.fecha_recepcion,
          toca_id: this.apelacion_data.toca_id,
          amparo: this.amparo,
          tribunal_id: this.tribunal_id,
          // status: this.status,
          dias_termino: this.dias_termino,
          quejoso: this.quejoso,
          efectos: this.efectos,
          observaciones: this.observaciones,
          tipo_registro: this.tipo_registro,
        }
        this.$store.dispatch("CREATE_AMPARO", { url: "/amparo", data:amparo }).then(response => {
            console.log(response);
            this.loading = false;
            if (response.data.status == 'error') {
              var titleSwal = 'Error!!!'
              var textSwal = "HUBO ERROR"
              var iconSwal = "error"
              var timerSwal = 3000
              this.loading = false;
            } else {
              var titleSwal = 'Exito!!!'
              var textSwal = 'Amparo Registrado'
              var iconSwal = "success"
              var timerSwal = 1000
              this.loading = false;
            }
            self = this;
            this.$swal({
              title: titleSwal,
              text: textSwal,
              icon: iconSwal,
              confirmButtonText: "Aceptar",
              timer: timerSwal
            }).then(function() {
              // window.location.reload();
            //  self.$store.dispatch("GET_TOCAS", { url: "tocas/filter/", sala_id: self.sala_id });

              self.dialog = false;
            });
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
      resetValidation () {
        this.dialog = false
        this.$refs.form.resetValidation()
        this.amparo=""
        this.numero_oficio=""
        this.fecha_recepcion=""
        this.dias_termino=""
        this.quejoso=""
        this.efectos=""
        this.observaciones=""
        this.tipo_registro=""
      },
    }
  };
</script>
